// @flow

// - Stylesheet
import './style/index.less';

import App                    from 'app';
import Theme                  from '@insolus/core/views/theme';
import { __ }                 from '@insolus/i18n';
import AppView                from './layout/app';
import pages, { requirePage } from './pages';
import browserUpdate          from 'browser-update';

class FrontTheme extends Theme {
    initialize() {
        this.pages = pages;

        // eslint-disable-next-line no-new
        new AppView('.app');

        browserUpdate({
            required : { i: 12 },
            reminder : 0,
            noclose  : true,
            api      : '2018.12',
            text     : __('Cher utilisateur, afin de pouvoir vous inscrire merci de bien vouloir utiliser <a {up_but} > un autre navigateur'),

            // impossible d'utiliser du camelCase
            // eslint-disable-next-line
            no_permanent_hide : true
        });
    }

    loadPage(page: string): boolean | Object {
        if (!this.pageExists(page)) {
            return false;
        }
        return requirePage(page);
    }
}

// - Init.
App.setTheme(FrontTheme);



// WEBPACK FOOTER //
// ./src/views/themes/front/index.js